import React from "react"
import { Chart } from "devextreme-react"
import {
  ArgumentAxis,
  Label,
  Series,
  Legend,
  ValueAxis,
  Grid,
  CommonSeriesSettings,
  SeriesTemplate,
  LoadingIndicator,
  Size,
  Aggregation,
  ZoomAndPan,
  Tooltip,
  VisualRange,
} from "devextreme-react/chart"
import { connect } from "react-redux"

import {
  paymentChartDataStoreGenerator,
  allPaymentChartDataStoreGenerator,
} from "../../shared/ConcurStore"
import { dashboardSelectors } from "../../../../state/ducks/dashboard"
import { calculateVisualRange } from "../../shared/utilities"

const PaymentChart = ({ paymentId, timeRange, refreshUuid }) => {
  const paymentChartDataStore = paymentId
    ? paymentChartDataStoreGenerator(paymentId, { timeRange })
    : allPaymentChartDataStoreGenerator({ timeRange })

  return (
    <Chart dataSource={paymentChartDataStore} palette="Soft Pastel">
      <ArgumentAxis
        aggregationInterval={timeRange.aggregationInterval}
        argumentType="datetime"
        maxValueMargin={0.1}
        minValueMargin={0.1}
        valueMarginsEnabled={true}
      >
        <Label wordWrap="none" overlappingBehavior="rotate" />
        <VisualRange defaultStartValue={calculateVisualRange(timeRange)} />
      </ArgumentAxis>
      <CommonSeriesSettings
        argumentField="timestamp"
        hoverMode="allArgumentPoints"
        type="bar"
        valueField="id"
      >
        <Aggregation enabled={true} method="count" />
      </CommonSeriesSettings>
      <Legend
        horizontalAlignment="center"
        verticalAlignment="bottom"
        visible={true}
      />
      <LoadingIndicator enabled={true} />
      <ValueAxis
        allowDecimals={false}
        maxValueMargin={0.1}
        minValueMargin={0.1}
        showZero={true}
        type="logarithmic"
        valueMarginsEnabled={true}
        valueType="numeric"
      >
        <Grid opacity="0.3" />
      </ValueAxis>
      <Series name="total" />
      <SeriesTemplate nameField="status" />
      <Size width="100%" />
      <Tooltip enabled={true} />
      <ZoomAndPan argumentAxis="both" />
    </Chart>
  )
}

export { PaymentChart }

const mapStateToProps = state => ({
  timeRange: dashboardSelectors.selectTimeRange(state),
  refreshUuid: dashboardSelectors.selectAutoRefreshUuid(state),
})
export default connect(mapStateToProps, null)(PaymentChart)
